export const parseStringToFloat = (
    string: string | null | undefined,
): number => {
    if (string === undefined || string === null) {
        return NaN;
    }
    return parseFloat(string);
};

export const parseStringToInt = (
    string: string | null | undefined,
    radix: number | undefined,
): number => {
    if (string === undefined || string === null) {
        return NaN;
    }
    return parseInt(string, radix);
};
